// Reine LOGIK-Datei - keine Daten hier drin, nur Funktionen. Die eigentlichen ligaId-Zuordnungen
// liegen in ligaKonstanten.js (bewusst getrennt, damit ein Neuaufbau dieser Logik-Datei nicht
// versehentlich die dort gepflegten echten IDs überschreibt).
import {
  LARGE_WETTBEWERBE,
  XL_WETTBEWERBE,
  TOP5_LIGEN,
  EUROPAPOKAL_LIGEN,
  NATIONALMANNSCHAFT_LIGEN
} from './ligaKonstanten.js'

const LARGE_IDS = new Set(LARGE_WETTBEWERBE.map(w => w.id).filter(id => id != null))
const XL_IDS = new Set(XL_WETTBEWERBE.map(w => w.id).filter(id => id != null))

// Gibt 'standard' | 'large' | 'xl' zurück - direkt als CSS-Modifier-Suffix nutzbar
// (z.B. `tm-card__liga-logo--${ligaLogoGroesse(match.ligaId)}`).
export function ligaLogoGroesse(ligaId) {
  if (ligaId == null) return 'standard'
  if (XL_IDS.has(ligaId)) return 'xl'
  if (LARGE_IDS.has(ligaId)) return 'large'
  return 'standard'
}

// Gleiche ID-Zuordnung wie ligaLogoGroesse - für die Länderflagge (z.B. in Story-Karten).
// Bewusst als EIGENE Funktion (nicht einfach ligaLogoGroesse wiederverwendet), damit man die
// beiden später unabhängig voneinander anpassen kann, falls Liga-Logo und Flagge doch mal
// unterschiedliche Größenregeln brauchen sollten.
export function flaggenGroesse(ligaId) {
  if (ligaId == null) return 'standard'
  if (XL_IDS.has(ligaId)) return 'xl'
  if (LARGE_IDS.has(ligaId)) return 'large'
  return 'standard'
}


const TOP5_IDS = new Set(TOP5_LIGEN.map(l => l.id).filter(id => id != null))
const EUROPAPOKAL_IDS = new Set(EUROPAPOKAL_LIGEN.map(l => l.id).filter(id => id != null))
const NATIONALMANNSCHAFT_IDS = new Set(NATIONALMANNSCHAFT_LIGEN.map(l => l.id).filter(id => id != null))

// Gibt 'top5' | 'europapokal' | 'nationalmannschaft' | 'sonstige' zurück - direkt als
// CSS-Modifier-Suffix nutzbar (z.B. `tm-kalender__punkt--${ligaKategorie(ligaId)}`).
export function ligaKategorie(ligaId) {
  if (ligaId == null) return 'sonstige'
  if (TOP5_IDS.has(ligaId)) return 'top5'
  if (EUROPAPOKAL_IDS.has(ligaId)) return 'europapokal'
  if (NATIONALMANNSCHAFT_IDS.has(ligaId)) return 'nationalmannschaft'
  return 'sonstige'
}